import { useEffect, useState } from 'react';
import { useDynamicTypeContext } from '@/components/accessibility/DynamicTypeProvider';
import { Info } from 'lucide-react';
import { Card } from './card';
import { Badge } from './badge';

/**
 * Indicador visual de Dynamic Type ativo
 * Útil para debug e para mostrar ao usuário que o app respeita suas preferências
 */
export function AccessibilityIndicator() {
  const { category, scale, isAccessibilitySize } = useDynamicTypeContext();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Mostrar indicador apenas quando em modo acessibilidade
    setIsVisible(isAccessibilitySize);
  }, [isAccessibilitySize]);

  if (!isVisible) return null;

  return (
    <Card className="fixed bottom-20 right-4 p-3 bg-primary/90 text-primary-foreground shadow-lg z-[9998] max-w-[200px]">
      <div className="flex items-start gap-2">
        <Info className="w-4 h-4 mt-0.5 flex-shrink-0" />
        <div className="flex-1 min-w-0">
          <p className="text-xs font-semibold mb-1">Modo Acessibilidade</p>
          <div className="flex flex-wrap gap-1">
            <Badge variant="secondary" className="text-[10px] px-1.5 py-0.5">
              {category}
            </Badge>
            <Badge variant="secondary" className="text-[10px] px-1.5 py-0.5">
              {(scale * 100).toFixed(0)}%
            </Badge>
          </div>
          <p className="text-[10px] mt-1 opacity-90">
            Tamanho de texto ajustado às suas preferências
          </p>
        </div>
      </div>
    </Card>
  );
}
